import React from 'react'
import PropTypes from 'prop-types';

import TitledPage from '../TitledPage'
import VideoDialog from '../VideoDialog'

export class LandingPage extends React.Component {

    static childContextTypes = {
        page: PropTypes.object,
    }

    constructor(...args) {
        super(...args)
        this.state = {videoOpen: false}
    }

    openPlayer = () => {
        this.setState({videoOpen: true})
    }

    closePlayer = () => {
        this.setState({videoOpen: false})
    }

    getChildContext = () => {
        console.log("Getting landing page context")
        return {page: this}
    }

    render() {
        const {title,children} = this.props
        const {videoOpen} = this.state
        return (
            <TitledPage title={title}>
                <VideoDialog open={videoOpen} onClose={this.closePlayer}/>
                {children}
            </TitledPage>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/landinglib/LandingPage.jsx